import { ITokenIntelParams } from "../../@types/api";
import { BaseAPI } from "./BaseAPI";

export class TokenIntelAPI {
  static getTopHolderMovements = async ({
    chain,
    token_address,
  }: ITokenIntelParams) => {
    return BaseAPI.callAPI({
      url: `token/${token_address}/movements/top_holders/`,
      params: {
        chain,
      },
    });
  };

  static getCexMovements = async ({
    chain,
    token_address,
  }: ITokenIntelParams) => {
    return BaseAPI.callAPI({
      url: `token/${token_address}/movements/cex/`,
      params: {
        chain,
      },
    });
  };

  static getFreshWalletMovements = async ({
    chain,
    token_address,
  }: ITokenIntelParams) => {
    return BaseAPI.callAPI({
      url: `token/${token_address}/movements/fresh_wallets/`,
      params: {
        chain,
      },
    });
  };

  static getSmartMoneyMovements = async ({
    chain,
    token_address,
  }: ITokenIntelParams) => {
    return BaseAPI.callAPI({
      url: `token/${token_address}/movements/smart_money/`,
      params: {
        chain,
      },
    });
  };
}
